import { Module } from 'vuex-module-decorators'
import SalesCartAbstract from '~/store/sales-cart-abstract'

@Module({
  name: 'sales-cart-promo',
  stateFactory: true,
  namespaced: true,
})
export default class SalesCartPromo extends SalesCartAbstract {}
